// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3DdlG","author":"Table_author__4i0kF","authorImage":"Table_authorImage__A7Yvm","unreadRow":"Table_unreadRow__1Q1_N"};